import QuoteModel from '@/Modules/Quote/QuoteModel.js'

export default class PolicyModel extends QuoteModel {}
